import type { PageMeta } from '../../../generated/frontend'
import { useBackStack } from '../../../shared/BrowserBackStackProvider'
import { getDataLayerScripts } from '../../../shared/data-layer'
import { getDFPScripts } from '../../../shared/dfp'
import { useFullUrl } from '../../../shared/hooks/useFullUrl'
import { useGenericMetaTags } from '../../../shared/hooks/useGenericMetaTags'
import type { PageInfo } from '../../../shared/types'
import { removeFalsy, removeUrlQueryStringAndFragment } from '../../../shared/utils'
import { getPreviousUrl } from '../../../shared/utils/getPreviousUrl/getPreviousUrl'

export const useEnergyMetaTags = () => {
  const { getGenericMetaTags } = useGenericMetaTags()
  const { getDataLayerItems } = useDataLayerItems()
  const { getFullUrl } = useFullUrl()

  return {
    getMetaTags: (meta: PageMeta) => [
      ...getGenericMetaTags({ meta }),
      ...getDataLayerItems(meta, getFullUrl()),
    ],
  }
}

const useDataLayerItems = () => {
  const backStack = useBackStack()
  const previousUrl = getPreviousUrl({ backStack: backStack })

  return {
    getDataLayerItems(meta: PageMeta, fullUrl: string) {
      const pageInfo: PageInfo = {
        vertical: 'energy',
        content_type: 'energy',
        wcdPageUrl: removeUrlQueryStringAndFragment(fullUrl),
        ...(previousUrl && { previousWcdPageUrl: previousUrl }),
      }

      return [...getDataLayerScripts([removeFalsy(pageInfo)]), ...getDFPScripts([], pageInfo)]
    },
  }
}
